import { render, staticRenderFns } from "./PasswordPolicy.vue?vue&type=template&id=9b61851e"
import script from "./PasswordPolicy.vue?vue&type=script&lang=js"
export * from "./PasswordPolicy.vue?vue&type=script&lang=js"
import style0 from "./PasswordPolicy.vue?vue&type=style&index=0&id=9b61851e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports